export default __webpack_public_path__ + "static/media/order-step3.2e256b6f.svg";